import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import FeedHolder from "../components/feed-holder";
import Holder from "../components/holder";
import InputModule from "../components/input-module";
import { useState,useEffect } from "react";
import { openSiteAdder } from "../functions/openInput";
import { fetchIdeas } from "../functions/fetchIdeas";
import CustomPostModule from "../components/custom-post-module";
import { openCustomPostModule } from "../functions/openCustomPostModule";


function IdeasPage(){
    //SCHEMA FOR IDEAS ITEM = {date:'09 Jun 2024',title:'Why you shouldn’t compare',status:2,generatedFrom:'Why I Am Perfect And All My Competitors Suck'},
    const [inputOpen,setInputOpen] = useState(false);
    const [ideas,setIdeas] = useState([]);
    const [fullyLoaded, changeFullyLoaded] = useState(false);

    const handleClick = () => {
        openSiteAdder(setInputOpen,inputOpen);
    }

        const [customPostModuleOpen,setCustomPostModuleOpen] = useState(false);
    
        const handleClick2 = () =>{
            openCustomPostModule(setCustomPostModuleOpen,customPostModuleOpen)
        }
    

    useEffect(() => {
        const waitForIdeas = async() => {
        await fetchIdeas(setIdeas);
        changeFullyLoaded(true);
        }
        waitForIdeas();
      }, []);

    return <>
    <Header CTA='Add site' functionForButton={handleClick} CTA2="Create post" functionForButton2={handleClick2} context="ideas"></Header>
    <Holder 
    left={<PageNavigator numberSelected={1}/>}
    right={<><PageTitle text='Here are your content ideas based off your feed.' heading='Your content ideas'></PageTitle>
    <FeedHolder feedItems={ideas} context='ideas' isLoaded={fullyLoaded} openSiteAdder={handleClick}/></>}
    />
    <InputModule functionForButton={handleClick} display={inputOpen ? 'flex' : 'none'}/>
    <CustomPostModule display={customPostModuleOpen ? 'flex' : 'none'} functionForButton={handleClick2} />
    </>
}
    
export default IdeasPage;